import { render, staticRenderFns } from "./CaseFileRail.vue?vue&type=template&id=0097f37e&scoped=true"
import script from "./CaseFileRail.vue?vue&type=script&lang=js"
export * from "./CaseFileRail.vue?vue&type=script&lang=js"
import style0 from "./CaseFileRail.vue?vue&type=style&index=0&id=0097f37e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0097f37e",
  null
  
)

export default component.exports